/* eslint-disable eqeqeq */
import React from "react";
import OrderLineList from "./OrderLineList";
import { Table, Row, Col, Collapse, Input, Select, DatePicker } from "antd";
import { withRouter } from "react-router-dom";
import API_URL from "../../constants/API_URL";
import moment from "moment";
import { connect } from "react-redux";
import { posStorageAction } from "../../redux/actions/posStorageAction";

const axios = require("axios");
const { Panel } = Collapse;

class OrderList extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      data: [],
      pagination: {},
      loading: false,
      pageNumber: 0,
      docno: "",
      onlineOrderNo: "",
      status: "",
      branch: "",
      warehouse: "",
      customer: "",
      payMethodList: [],
      payMethod: "",
      orderDate: "",
      branchsList: [],
      customerList: [],
      warehousesList: [],
      orderId: "",
      order_status: [],
      showSaleOrderLine: false,
      sortField: null,
      sortOrder: "ascend",
    };
    this.lang = this.props.language.INJAZ_POS_ONLINESALEORDERLIST.SETUP;
  }

  componentDidMount() {
    if (localStorage.getItem("onlinesaleorderslistPage") == null) {
      localStorage.setItem("onlinesaleorderslistPage", 0);
    }
    this.fetch();
    let accessToken = localStorage.getItem("accessToken");
    let tokenType = localStorage.getItem("tokenType");
    var self = this;
    axios({
      method: "GET",
      url: API_URL + "parametersListByParaType",
      params: {
        paraType: "ORDER_STATUS",
        lang: localStorage.getItem("lang"),
      },
      headers: {
        Authorization: tokenType + " " + accessToken,
        "Content-Type": "application/json",
      },
    })
      .then(function(response) {
        self.setState({
          order_status: response.data,
        });
      })
      .catch(function(error) {
        //message.error(error.response.data.message);
      });
    var authOptions = {
      method: "GET",
      url: API_URL + "branchsList",
      params: {
        clientId: localStorage.getItem("clientId"),
        lang: localStorage.getItem("lang"),
      },
      headers: {
        Authorization: tokenType + " " + accessToken,
        "Content-Type": "application/json",
      },
    };
    axios(authOptions)
      .then((result) => {
        this.setState({ branchsList: result.data });
      })
      .catch((err) => {});
    let authOptionsWareHouse = { ...authOptions };
    authOptionsWareHouse.url = API_URL + "warehousesList";
    axios(authOptionsWareHouse)
      .then((result) => {
        this.setState({ warehousesList: result.data });
      })
      .catch((err) => {});
    let authOptionspayMethod = { ...authOptions };
    authOptionspayMethod.url = API_URL + "customerList";
    axios(authOptionspayMethod)
      .then((result) => {
        this.setState({ customerList: result.data });
      })
      .catch((err) => {});
    var payMethodListauthOptions = {
      method: "GET",
      url: API_URL + "paymentMethodsList",
      params: {
        clientId: localStorage.getItem("clientId"),
        lang: localStorage.getItem("lang"),
      },
      headers: {
        Authorization: tokenType + " " + accessToken,
        "Content-Type": "application/json",
      },
    };
    axios(payMethodListauthOptions)
      .then((result) => {
        this.setState({ payMethodList: result.data });
      })
      .catch((err) => {});
  }
  onChangeSearch = (e) => {
    this.setState({ [e.target.name]: e.target.value }, () => {
      this.fetch();
    });
  };

  handleReset = (clearFilters) => {
    clearFilters();
    this.setState({ searchText: "" });
    this.fetch();
  };

  handleTableChange = (pagination, filters, sorter) => {
    const pager = { ...this.state.pagination };
    pager.current = pagination.current;
    this.setState({
      pagination: pager,
      pageNumber: pagination.current,
    });

    if (
      sorter.field == this.state.sortField &&
      sorter.order == this.state.sortOrder
    ) {
      if (this.state.pageNumber !== pager.current) {
        this.fetch({
          page: pagination.current,
        });
      }
    } else {
      this.fetch({
        results: pagination.pageSize,
        page: pagination.current,
        sortField: sorter.field,
        sortOrder: sorter.order,
        ...filters,
      });
    }
  };

  fetch = (params = {}) => {
    let accessToken = localStorage.getItem("accessToken");
    let tokenType = localStorage.getItem("tokenType");
    let clientId = localStorage.getItem("clientId");
    let lang = localStorage.getItem("lang");
    let page;
    let sortOrder = "";
    // console.log(params.page)
    this.setState({
      loading: true,
      sortOrder: params.sortOrder,
      sortField: params.sortField,
    });
    if (params.page) {
      page = params.page - 1;
      localStorage.setItem("onlinesaleorderslistPage", page);
    } else {
      if (localStorage.getItem("onlinesaleorderslistPage")) {
        page = parseInt(localStorage.getItem("onlinesaleorderslistPage"));
      } else {
        page = 0;
      }
    }
    if (params.sortOrder && params.sortOrder.toString() === "ascend") {
      sortOrder = "ASC";
    } else {
      sortOrder = "DESC";
    }
    let payMethod = null;
    if (this.state.payMethod) {
      payMethod = this.state.payMethod;
    }
    let status = null;
    if (params.status) {
      status = params.status;
    } else if (this.state.status) {
      status = this.state.status;
    }
    let branch = null;
    if (params.branch) {
      branch = params.branch;
    } else if (this.state.branch) {
      branch = this.state.branch;
    }
    let warehouse = null;
    if (params.warehouse) {
      warehouse = params.warehouse;
    } else if (this.state.warehouse) {
      warehouse = this.state.warehouse;
    }
    let customer = null;
    if (params.customer) {
      customer = params.customer;
    } else if (this.state.customer) {
      customer = this.state.customer;
    }

    let orderDate = null;
    if (params.orderDate) {
      orderDate = params.orderDate;
    } else if (this.state.orderDate) {
      orderDate = this.state.orderDate;
    }

    let data = {
      lang,
      clientId: clientId,
      sortColumn: params.sortField,
      documentNo: params.docno || this.state.docno || "",
      onlineOrderNo: params.onlineOrderNo || this.state.onlineOrderNo || null,
      page,
      status,
      orderDate,
      branch,
      warehouse,
      payMethod,
      customer,
      size: window.location.href.split("pos").length > 1 ? 5 : 10,
      sortOrder,
      priority: null,
    };
    // console.log(data)

    axios({
      url: API_URL + "onlineSaleOrdersByClient",
      method: "POST",
      data,
      headers: {
        Authorization: tokenType + " " + accessToken,
        "Content-Type": "application/json",
      },
    })
      .then((data) => {
        // console.log(data)
        const pagination = { ...this.state.pagination };
        pagination.total = data.data.totalElements;
        pagination.current = page + 1;

        this.setState({
          loading: false,
          data: data.data.content,
          pagination,
        });
      })
      .catch((err) => {
        // console.log(err.message)
      });
  };

  render() {
    const thead = this.lang.TABLEHEADERS;
    const searchTitle = this.lang.SEARCHBOXTITLE;
    this.columns2 = [
      {
        title: (
          <span>
            {thead.ORDERNO}
            <br />
            <input
              placeholder={searchTitle.ORDERNO}
              type="text"
              name="docno"
              onChange={this.onChangeSearch}
              className="inputInTable"
            />
          </span>
        ),
        dataIndex: "documentNo",
        sorter: true,
        render: (text, record) => (
          <button
            onClick={() => {
              this.setState({ showSaleOrderLine: true, orderId: record.id });
            }}
            className="link-button"
          >
            {text}
          </button>
        ),
      },
      {
        title: (
          <span>
            {thead.CUSTOMER}
            <br />
            <Select
              style={{ width: "100%" }}
              defaultValue={searchTitle.CUSTOMER}
              onChange={(e) =>
                this.setState({ customer: e }, () => {
                  this.fetch();
                })
              }
            >
              {this.state.customerList.map((item) => (
                <Select.Option value={item.id} key={item.id}>
                  {item.name}
                </Select.Option>
              ))}
            </Select>
          </span>
        ),
        dataIndex: "customer",
        sorter: true,
        render: (text, record) => (
          <button
            onClick={() => {
              this.setState({ showSaleOrderLine: true, orderId: record.id });
            }}
            className="link-button"
          >
            {this.state.customerList.length > 0 &&
              this.state.customerList.filter((item) => item.id == text).length >
                0 &&
              this.state.customerList.filter((item) => item.id == text)[0].name}
          </button>
        ),
      },
      {
        title: (
          <span>
            {thead.PAYMETHOD}
            <br />
            <Select
              style={{ width: "100%" }}
              defaultValue={searchTitle.PAYMETHOD}
              onChange={(e) =>
                this.setState({ payMethod: e }, () => {
                  this.fetch();
                })
              }
            >
              {this.state.payMethodList.map((item) => (
                <Select.Option value={item.id} key={item.id}>
                  {item.name}
                </Select.Option>
              ))}
            </Select>
          </span>
        ),
        dataIndex: "payMethod",
        sorter: true,
        render: (text, record) => (
          <button
            className="link-button"
            onClick={() => {
              this.setState({ showSaleOrderLine: true, orderId: record.id });
            }}
          >
            {this.state.payMethodList.length > 0 &&
              this.state.payMethodList.filter((item) => item.id == text)
                .length > 0 &&
              this.state.payMethodList.filter((item) => item.id == text)[0]
                .name}
          </button>
        ),
      },
      {
        title: thead.TABLE,
        dataIndex: "flrTableName",
        sorter: true,
        render: (text, record) => <span>{text}</span>,
      },
      {
        title: thead.TOTAL_NET,
        dataIndex: "totalNet",
        sorter: true,
        render: (text, record) => <span>{text}</span>,
      },
      {
        title: thead.MDATE,
        dataIndex: "orderDate",
        sorter: true,
        render: (text, record) => <span>{text}</span>,
      },
    ];
    this.columns = [
      {
        title: (
          <span>
            {thead.ORDERNO}
            <br />
            <Input.Search
              placeholder={searchTitle.ORDERNO}
              type="text"
              name="docno"
              onChange={this.onChangeSearch}
            />
          </span>
        ),
        dataIndex: "documentNo",
        sorter: true,
        render: (text, record) => (
          <button
            onClick={() => {
              this.setState({ showSaleOrderLine: true, orderId: record.id });
            }}
            className="link-button"
          >
            {text}
          </button>
        ),
      },
      {
        title: (
          <span>
            Online Order No
            {/* {thead.ORDERNO} */}
            <br />
            <Input.Search
              placeholder={searchTitle.ORDERNO}
              type="text"
              name="onlineOrderNo"
              onChange={this.onChangeSearch}
            />
          </span>
        ),
        dataIndex: "onlineOrderNo",
        sorter: true,
        render: (text, record) => (
          <button className="link-button">{text}</button>
        ),
      },
      {
        title: (
          <span>
            {thead.BRANCH}
            <br />
            <Select
              style={{ width: "100%" }}
              defaultValue={searchTitle.BRANCH}
              onChange={(e) =>
                this.setState({ branch: e }, () => {
                  this.fetch();
                })
              }
            >
              {this.state.branchsList.map((item) => (
                <Select.Option value={item.id} key={item.id}>
                  {item.name}
                </Select.Option>
              ))}
            </Select>
          </span>
        ),
        dataIndex: "branch",
        sorter: true,
        render: (text, record) => (
          <button
            onClick={() => {
              this.setState({ showSaleOrderLine: true, orderId: record.id });
            }}
            className="link-button"
          >
            {this.state.branchsList.length > 0 &&
              this.state.branchsList.filter((item) => item.id == text).length >
                0 &&
              this.state.branchsList.filter((item) => item.id == text)[0].name}
          </button>
        ),
      },
      {
        title: (
          <span>
            {thead.CUSTOMER}
            <br />
            <Select
              style={{ width: "100%" }}
              defaultValue={searchTitle.CUSTOMER}
              onChange={(e) =>
                this.setState({ customer: e }, () => {
                  this.fetch();
                })
              }
            >
              {this.state.customerList.map((item) => (
                <Select.Option value={item.id} key={item.id}>
                  {item.name}
                </Select.Option>
              ))}
            </Select>
          </span>
        ),
        dataIndex: "customer",
        sorter: true,
        render: (text, record) => (
          <button
            onClick={() => {
              this.setState({ showSaleOrderLine: true, orderId: record.id });
            }}
            className="link-button"
          >
            {this.state.customerList.length > 0 &&
              this.state.customerList.filter((item) => item.id == text).length >
                0 &&
              this.state.customerList.filter((item) => item.id == text)[0].name}
          </button>
        ),
      },

      {
        title: (
          <span>
            {thead.WAREHOUSE}
            <br />
            <Select
              style={{ width: "100%" }}
              defaultValue={searchTitle.WAREHOUSE}
              onChange={(e) =>
                this.setState({ warehouse: e }, () => {
                  this.fetch();
                })
              }
            >
              {this.state.warehousesList.map((item) => (
                <Select.Option value={item.id} key={item.id}>
                  {item.name}
                </Select.Option>
              ))}
            </Select>
          </span>
        ),
        dataIndex: "warehouse",
        sorter: true,
        render: (text, record) => (
          <button
            onClick={() => {
              this.setState({ showSaleOrderLine: true, orderId: record.id });
            }}
            className="link-button"
          >
            {this.state.warehousesList.length > 0 &&
              this.state.warehousesList.filter((item) => item.id == text)
                .length > 0 &&
              this.state.warehousesList.filter((item) => item.id == text)[0]
                .name}
          </button>
        ),
      },

      {
        title: (
          <span>
            {this.lang.TABLEHEADERS.MDATE}
            <br />
            <DatePicker
              placeholder={searchTitle.MDATE}
              onChange={(e) => {
                e
                  ? this.setState(
                      { orderDate: moment(e).format("YYYY-MM-DD") },
                      () => {
                        this.fetch();
                      },
                    )
                  : this.setState({ orderDate: "" }, () => {
                      this.fetch();
                    });
              }}
            />
          </span>
        ),
        dataIndex: "orderDate",
        sorter: true,
        render: (text, record) => (
          <button
            onClick={() => {
              this.setState({ showSaleOrderLine: true, orderId: record.id });
            }}
            className="link-button"
          >
            {text}
          </button>
        ),
      },
      {
        title: (
          <span>
            {this.lang.TABLEHEADERS.STATUS}
            <br />
            <Select
              defaultValue={searchTitle.STATUS}
              style={{ width: "100%" }}
              onChange={(e) =>
                this.setState({ status: e }, () => {
                  this.fetch();
                })
              }
            >
              {this.state.order_status.length > 0 &&
                this.state.order_status.map((item) => (
                  <Select.Option value={item.paramCode} key={item.id}>
                    {item.name}
                  </Select.Option>
                ))}
            </Select>
          </span>
        ),
        dataIndex: "status",
        sorter: true,
        render: (text, record) => (
          <button
            onClick={() => {
              this.setState({ showSaleOrderLine: true, orderId: record.id });
            }}
            className="link-button"
          >
            {this.state.order_status.length > 0 &&
              this.state.order_status.filter((item) => item.paramCode == text)
                .length > 0 &&
              this.state.order_status.filter(
                (item) => item.paramCode == text,
              )[0].name}
          </button>
        ),
      },
      {
        title: <span>{this.lang.TABLEHEADERS.OPEN_POS}</span>,
        dataIndex: "",
        sorter: true,
        render: (text, record) => (
          <button
            className="openPOSButton"
            onClick={() => {
              let name;
              name =
                this.state.customerList.length > 0 &&
                this.state.customerList.filter(
                  (item) => item.id == record.customer,
                ).length > 0 &&
                this.state.customerList.filter(
                  (item) => item.id == record.customer,
                )[0].name;
              let posStorage = {
                customer: record.customer,
                customerName: name,
                orderId: record.id,
                floorId: record.flrTable,
                pos: true,
              };
              this.props.posStorageAction(posStorage);
              {
                /* localStorage.setItem('posStorage', JSON.stringify(posStorage)) */
              }
              this.props.history.push("pos");
            }}
          >
            {this.lang.TABLEHEADERS.OPEN_POS}
          </button>
        ),
      },
    ];

    const { props } = this;
    var lang = props.language.INJAZ_POS_ONLINESALEORDERLIST;
    return (
      <div>
        <div>
          <h2 className="title">{lang.TITLE}</h2>
        </div>
        <Table
          style={{ marginTop: "10px" }}
          columns={
            window.location.href.split("pos").length > 1
              ? this.columns2
              : this.columns
          }
          dataSource={this.state.data}
          pagination={this.state.pagination}
          loading={this.state.loading}
          onChange={this.handleTableChange}
          rowKey="id"
          onRow={(record, rowIndex) => {
            return;
            return {
              onClick: (event) => {
                this.setState({ showSaleOrderLine: true, orderId: record.id });
              },
            };
          }}
        />
        {this.state.showSaleOrderLine && (
          <Collapse defaultActiveKey={["1"]}>
            <Panel
              header={this.props.language.INJAZ_POS_ORDERLISTLINE.TITLE}
              key="1"
            >
              <OrderLineList
                {...this.props}
                orderId={this.state.orderId}
                order_status={this.state.order_status}
              />
            </Panel>
          </Collapse>
        )}
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    posStorage: state.posStorage,
  };
};
const mapDispatchToProps = (dispatch) => {
  return {
    posStorageAction: (payload) => dispatch(posStorageAction(payload)),
  };
};
export default connect(mapStateToProps, mapDispatchToProps, null, {
  forwardRef: true,
})(withRouter(OrderList));
